// extracted by mini-css-extract-plugin
export default {"wrapper":"_1ygrPa6TPlMIoDyXMHkRr7"};